import { gsap, Power2 } from 'gsap';
import { Transition } from '../Transition';
import '../types';

export class Fade extends Transition {
  /**
   * @constructor
   * @class Fade
   * @classdesc Controls all Fade transitions
   * @param {options} options
   */
  constructor(options) {
    super(options);
  }

  /**
   * Get animation properties
   * @returns {object} Animations properties
   */
  _getAnimationProperties() {
    return {
      animateIn: {
        to: {
          opacity: 1,
        },
      },
      animateOut: {
        to: {
          opacity: 0,
        },
      },
    };
  }

  /**
   * Method for the animation "in"
   * @returns {Promise}
   */
  in() {
    return new Promise((resolve) => {
      const duration = this._getOptionValue('duration');
      const {
        animateIn: { to },
      } = this._getAnimationProperties();
      const container = this.createTransitionContainer();
      const rect = document.createElement('div');
      const tl = new gsap.timeline({
        onComplete: () => {
          document.dispatchEvent(new Event('barbaAnimInEnd'));
          resolve();
        },
      });

      container.appendChild(rect);

      tl.set(rect, { attr: { class: 'wb-transition-fade' } });
      tl.to(rect, { duration, ease: Power2.easeOut, ...to });
    });
  }

  /**
   * Method for the animation "out"
   * @returns {Promise}
   */
  out() {
    return new Promise((resolve) => {
      const duration = this._getOptionValue('duration');
      const {
        animateOut: { to },
      } = this._getAnimationProperties();
      const rect = document.querySelector('.wb-transition-fade');
      const tl = new gsap.timeline({
        onComplete: () => {
          this.getTransitionContainer().remove();
          resolve();
        },
      });

      document.dispatchEvent(new Event('barbaAnimOutStart'));

      tl.to(rect, { duration, ease: Power2.easeOut, ...to });
    });
  }
}
